import { TrendingUp, AlertCircle, CheckCircle2, ArrowRight } from "lucide-react"

/** Placeholder intelligence brief - will be wired to a backend endpoint later */
export function IntelligenceBrief({ className }: { className?: string }) {
  // TODO: Wire to actual backend endpoint that generates daily intelligence brief
  return (
    <div class={`${className || ""}`}>
      <h3 class="text-sm font-semibold text-gray-500 mb-3">Daily Intelligence</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <BriefCard
          icon={<TrendingUp className="w-4 h-4 text-green-500" />}
          title="Deductions This Week"
          description="Ask me about recent deduction trends and totals."
          color="border-green-200 bg-green-50/50"
        />
        <BriefCard
          icon={<AlertCircle className="w-4 h-4 text-amber-500" />}
          title="Needing Attention"
          description="I can help prioritize which deductions to work on next."
          color="border-amber-200 bg-amber-50/50"
        />
        <BriefCard
          icon={<CheckCircle2 className="w-4 h-4 text-blue-500" />}
          title="Dispute Follow-ups"
          description="Ask about disputes that need follow-up or are overdue."
          color="border-blue-200 bg-blue-50/50"
        />
      </div>
    </div>
  )
}

interface BriefCardProps {
  icon: any
  title: string
  description: string
  color: string
}

function BriefCard({ icon, title, description, color }: BriefCardProps) {
  return (
    <div class={`rounded-xl border px-4 py-3 ${color}`}>
      <div class="flex items-center gap-2 mb-1">
        {icon}
        <p class="text-sm font-medium text-gray-700">{title}</p>
      </div>
      <p class="text-xs text-gray-500">{description}</p>
    </div>
  )
}
